module.exports = __webpack_public_path__ + "img/answer-block.ac3b271b.png";